var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16V24M34 12V20M32 2C36.8974 2 39.5463 2.74952 40.8642 3.33088C41.0398 3.40831 41.1275 3.44702 41.3808 3.68874C41.5326 3.83364 41.8098 4.25879 41.8811 4.45618C42 4.78548 42 4.96548 42 5.32548V26.8223C42 28.6398 42 29.5486 41.7274 30.0157C41.4502 30.4909 41.1828 30.7118 40.6639 30.8944C40.1537 31.0739 39.1239 30.876 37.0643 30.4803C35.6228 30.2033 33.913 30 32 30C26 30 20 34 12 34C7.10258 34 4.45373 33.2505 3.13577 32.6691C2.96025 32.5917 2.87249 32.553 2.6192 32.3113C2.46737 32.1664 2.19024 31.7412 2.11894 31.5438C2 31.2145 2 31.0345 2 30.6745L2 9.17771C2 7.36017 2 6.4514 2.27256 5.98429C2.5498 5.50913 2.81718 5.28823 3.33612 5.10562C3.84627 4.9261 4.87607 5.12397 6.93566 5.5197C8.37724 5.79668 10.087 6 12 6C18 6 24 2 32 2ZM27 18C27 20.7614 24.7614 23 22 23C19.2386 23 17 20.7614 17 18C17 15.2386 19.2386 13 22 13C24.7614 13 27 15.2386 27 18Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyLight);
export default __webpack_public_path__ + "static/media/money_light.9803920fb30c33fba459579cec5b5686.svg";
export { ForwardRef as ReactComponent };